import { render, staticRenderFns } from "./itemList.vue?vue&type=template&id=6f9c6875&scoped=true"
import script from "./itemList.vue?vue&type=script&lang=js"
export * from "./itemList.vue?vue&type=script&lang=js"
import style0 from "./itemList.vue?vue&type=style&index=0&id=6f9c6875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9c6875",
  null
  
)

export default component.exports